// Data fetching utilities
export async function fetchInitialData() {
    try {
        const [content, products] = await Promise.all([
            fetchContent(),
            fetchProducts()
        ]);
        return { content, products };
    } catch (error) {
        console.error("Error fetching initial data:", error);
        return { content: null, products: null };
    }
}

export async function fetchContent() {
    try {
        const apiUrl = import.meta.env.VITE_API_URL;
        const response = await fetch(`${apiUrl}/api/content`);
        if (!response.ok) {
            throw new Error(`HTTP error. status: ${response.status}`);
        }
        const data = await response.json();
        return data.data.content;
    } catch (error) {
        console.error("Error fetching content:", error);
        return null;
    }
}

export async function fetchProducts() {
    try {
        const apiUrl = import.meta.env.VITE_API_URL;
        const response = await fetch(`${apiUrl}/api/products`);
        if (!response.ok) {
            throw new Error(`HTTP error. status: ${response.status}`);
        }
        const data = await response.json();
        return data.data.products;
    } catch (error) {
        console.info("Backend failed, using mock data");
        try {
            const response = await fetch('/mocks/products.json');
            const data = await response.json();
            return processMockData(data).data.products;
        } catch (fallbackError) {
            console.error("Failed to fetch mock data:", fallbackError);
            return null;
        }
    }
}

function processMockData(data) {
    const isProd = import.meta.env.PROD;

    if (!data || !data.data.products) return data;

    // Mark products as unavailable in production
    if (isProd) {
        return {
            ...data,
            data: {
                ...data.data,
                products: data.data.products.map(product => ({
                    ...product,
                    variants: (product.variants || []).map(variant => ({
                        ...variant,
                        available: false,
                        inventory_quantity: 0
                    }))
                }))
            }
        };
    }

    return data;
}
